<template>
  <div class="mt-5">
    <h3>Logg inn</h3>
    <div class="row">
      <b-alert :show="!!loginError" variant="danger">
        {{ loginError }}
      </b-alert>
      <div class="col-md-6">
        <b-form @submit.prevent="onSubmit">
          <b-form-group id="email" label="E-postadresse"
                        label-for="email">
            <b-form-input
              id="email"
              v-model="form.email"
              type="email"
              required
              placeholder="Enter email"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="password" label="Passord"
                        label-for="password">
            <b-form-input
              id="password"
              v-model="form.password"
              required
              type="password"
              placeholder="Enter password"
            ></b-form-input>
          </b-form-group>
          <div class="mb-4">
            <a
              href="#"
              @click.prevent="forgot = true"
              class="text-muted text-small"
            >Glemt passord?</a
            >
          </div>
          <div
            class="invalid-feedback mt-2 mb-4"
            :style="{ display: authError ? 'block' : 'none' }"
          >
            Feil e-post eller passord
          </div>
          <b-button type="submit" variant="primary">Logg inn
          </b-button>
        </b-form>
        <div v-if="forgot" class="mt-5">
          <h5>Glemt passord</h5>
          <p>
            Fyll inn e-postadressen du har registrert hos oss og trykk ”Send”. Du
            får da tilsendt instruksjoner om hvordan du lager et nytt passord til
            din e-postadresse.
          </p>
          <b-alert :show="!!forgotError" variant="danger">
            {{ forgotError }}
          </b-alert>
          <label class="label" for="email">E-postadresse</label>
          <div class="form-group">
            <input
              id="email"
              name="email"
              type="email"
              class="form-control"
              v-model="forgotEmail"
              autocomplete="email"
              required
            />
          </div>

          <button
            @click.prevent="sendForgotPassword"
            type="submit"
            class="btn btn-block btn-primary btn-lg btn-uppercase"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  mounted () {
    if (this.$route.query.api_token) {
      this.form.api_token = this.$route.query.api_token
      this.onSubmit()
    }
  },
  computed: {
    ...mapGetters({ authError: 'auth/authStatus' }),
  },
  data () {
    return {
      forgot: false,
      rootUrl: process.env.VUE_APP_API_URL,
      forgotEmail: '',
      loginError: null,
      forgotError: null,
      form: {
        email: '',
        password: '',
        api_token: null,
        role: 'Supplier',
      },
    }
  },
  methods: {
    async onSubmit () {
      try {
        await this.$store.dispatch('auth/login', this.form)
        this.$router.push('/')
      } catch (error) {
        this.loginError = 'Feil e-post eller passord'
      }
    },
    sendForgotPassword () {
      this.$store.dispatch('auth/forgot', {
        email: this.forgotEmail,
      }).then(response => {
        this.$bvToast.toast(`Passordet ble sendt`, {
          variant: 'success',
          title: 'Nytt passord ble sendt',
          autoHideDelay: 5000,
        })
        this.forgot = false
        this.forgotEmail = ''
      }).catch((error) => {
        this.forgotError = error.message
      })
    },
  },
}
</script>

<style>
</style>
